<template>
  <v-menu
    bottom
    offset-y
    :nudge-bottom="8"
    elevation-0
    transition="slide-y-transition"
    :close-on-content-click="true"
    content-class="tasklist-row-action-menu__panel"
    :value="isOpen"
    @input="$emit('toggle', $event)"
    data-testid="tasklist__menu"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-tooltip top content-class="tooltip-top">
        <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
          <button
            type="button"
            class="tasklist-row-hover-actions__more-btn"
            v-bind="{ ...attrs, ...tooltipAttrs }"
            v-on="{ ...on, ...tooltipOn }"
            data-testid="tasklist__menu-btn"
          >
            <img
              src="/img/icons/fbc-icons/MoreActionsIcon.svg"
              alt="More actions"
              class="tasklist-row-hover-actions__more-icon"
            />
          </button>
        </template>
        <span>More</span>
      </v-tooltip>
    </template>

    <div class="tasklist-row-action-menu" data-testid="tasklist__row-action-menu">
      <template v-if="userType === 'manager'">
        <v-tooltip
          left
          content-class="tooltip-left"
          :disabled="!isEditLocked"
        >
          <template v-slot:activator="{ on, attrs }">
            <span
              class="tasklist-row-action-menu__item-wrap"
              :class="{ 'tasklist-row-action-menu__item-wrap--locked': isEditLocked }"
              v-bind="attrs"
              v-on="on"
            >
              <button
                type="button"
                class="tasklist-row-action-menu__item"
                :class="{ 'tasklist-row-action-menu__item--disabled': isEditLocked }"
                :disabled="isEditLocked"
                @click="onEditTask"
                data-testid="tasklist__edit-task-btn"
              >
                <span class="tasklist-row-action-menu__item-content">
                  <img
                    src="/img/icons/PenEditIcon.svg"
                    alt="Edit Task"
                    class="tasklist-row-action-menu__item-img tasklist-row-action-menu__item-img--menu"
                  />
                  <span class="tasklist-row-action-menu__item-label">Edit Task</span>
                </span>
              </button>
            </span>
          </template>
          <span>{{ editLockedHint }}</span>
        </v-tooltip>

        <button
          v-if="canLinkNoa"
          type="button"
          class="tasklist-row-action-menu__item"
          @click="onLinkNoa"
          data-testid="tasklist__link-noa-btn"
        >
          <span class="tasklist-row-action-menu__item-content">
            <img
              src="/img/icons/fbc-icons/LinkNoaAgent.svg"
              alt="Link Noa Agent"
              class="tasklist-row-action-menu__item-img tasklist-row-action-menu__item-img--menu"
            />
            <span class="tasklist-row-action-menu__item-label">Link Noa Agent</span>
          </span>
        </button>

        <button
          type="button"
          class="tasklist-row-action-menu__item"
          @click="onComments"
          data-testid="tasklist__comments-btn"
        >
          <span class="tasklist-row-action-menu__item-content">
            <span class="tasklist-row-action-menu__item-badge-wrap">
              <img
                src="/img/icons/fbc-icons/CommentsIcon.svg"
                alt="Comments"
                class="tasklist-row-action-menu__item-img tasklist-row-action-menu__item-img--menu"
              />
              <span
                v-if="hasUnreadComments"
                class="tasklist-row-action-menu__notify-dot"
                aria-hidden="true"
              />
            </span>
            <span class="tasklist-row-action-menu__item-label">Comments</span>
          </span>
        </button>

        <button
          type="button"
          class="tasklist-row-action-menu__item"
          @click="onDelete"
          data-testid="tasklist__delete-btn"
        >
          <span class="tasklist-row-action-menu__item-content">
            <img
              src="/img/icons/fbc-icons/DeleteActions.svg"
              alt="Delete"
              class="tasklist-row-action-menu__item-img tasklist-row-action-menu__item-img--menu"
            />
            <span class="tasklist-row-action-menu__item-label">Delete</span>
          </span>
        </button>
      </template>

      <template v-else-if="userType === 'preparer'">
        <button
          type="button"
          class="tasklist-row-action-menu__item"
          @click="onComments"
          data-testid="tasklist__comments-btn"
        >
          <span class="tasklist-row-action-menu__item-content">
            <span class="tasklist-row-action-menu__item-badge-wrap">
              <img
                src="/img/icons/fbc-icons/CommentsIcon.svg"
                alt="Comments"
                class="tasklist-row-action-menu__item-img tasklist-row-action-menu__item-img--menu"
              />
              <span
                v-if="hasUnreadComments"
                class="tasklist-row-action-menu__notify-dot"
                aria-hidden="true"
              />
            </span>
            <span class="tasklist-row-action-menu__item-label">Comments</span>
          </span>
        </button>

        <button
          v-if="canLinkNoa"
          type="button"
          class="tasklist-row-action-menu__item"
          @click="onLinkNoa"
          data-testid="tasklist__link-noa-btn"
        >
          <span class="tasklist-row-action-menu__item-content">
            <img
              src="/img/icons/fbc-icons/LinkNoaAgent.svg"
              alt="Link Noa Agent"
              class="tasklist-row-action-menu__item-img tasklist-row-action-menu__item-img--menu"
            />
            <span class="tasklist-row-action-menu__item-label">Link Noa Agent</span>
          </span>
        </button>
      </template>

      <template v-else-if="userType === 'approver'">
        <button
          type="button"
          class="tasklist-row-action-menu__item"
          @click="onComments"
          data-testid="tasklist__comments-btn"
        >
          <span class="tasklist-row-action-menu__item-content">
            <span class="tasklist-row-action-menu__item-badge-wrap">
              <img
                src="/img/icons/fbc-icons/CommentsIcon.svg"
                alt="Comments"
                class="tasklist-row-action-menu__item-img tasklist-row-action-menu__item-img--menu"
              />
              <span
                v-if="hasUnreadComments"
                class="tasklist-row-action-menu__notify-dot"
                aria-hidden="true"
              />
            </span>
            <span class="tasklist-row-action-menu__item-label">Comments</span>
          </span>
        </button>

        <button
          v-if="canLinkNoa"
          type="button"
          class="tasklist-row-action-menu__item"
          @click="onLinkNoa"
          data-testid="tasklist__link-noa-btn"
        >
          <span class="tasklist-row-action-menu__item-content">
            <img
              src="/img/icons/fbc-icons/LinkNoaAgent.svg"
              alt="Link Noa Agent"
              class="tasklist-row-action-menu__item-img tasklist-row-action-menu__item-img--menu"
            />
            <span class="tasklist-row-action-menu__item-label">Link Noa Agent</span>
          </span>
        </button>
      </template>

      <!-- <div
        class="tasklist-row-action-menu__divider"
        aria-hidden="true"
      /> -->

      <!-- <button
        type="button"
        class="tasklist-row-action-menu__item"
        @click="onHelpdesk"
        data-testid="tasklist__helpdesk-btn"
      >
        <span class="tasklist-row-action-menu__item-content">
          <v-icon class="tasklist-row-action-menu__item-icon">mdi-headphones</v-icon>
          <span class="tasklist-row-action-menu__item-label">Support</span>
        </span>
      </button> -->

      <button
        v-if="canUnlinkBot"
        type="button"
        class="tasklist-row-action-menu__item"
        @click="onUnlinkBot"
        data-testid="tasklist__unlink-bot-btn"
      >
        <span class="tasklist-row-action-menu__item-content">
          <v-icon class="tasklist-row-action-menu__item-icon">mdi-link-off</v-icon>
          <span class="tasklist-row-action-menu__item-label">Unlink {{ $constants.BOT_NAME }}</span>
        </span>
      </button>
    </div>
  </v-menu>
</template>

<script>
import './TasklistRowActionMenu.scss';
import { TASK_EDIT_MESSAGES } from '../../../../../utils/constants';
import { isApprovedTaskEditLocked } from '../../../../../utils/tasklistHelpers';

export default {
  name: 'TasklistRowActionMenu',
  props: {
    task: { type: Object, required: true },
    userType: { type: String, default: 'preparer' },
    metadata: { type: Object, default: () => ({}) },
    userid: { type: String, default: '' },
    isOpen: { type: Boolean, default: false },
  },
  computed: {
    isEditLocked() {
      return isApprovedTaskEditLocked(this.task);
    },
    editLockedHint() {
      return TASK_EDIT_MESSAGES.APPROVED_LOCKED;
    },
    canLinkNoa() {
      return (
        Array.isArray(this.metadata?.managerlist)
        && this.metadata.managerlist.includes(this.userid)
        && !this.task?.botid
      );
    },
    canUnlinkBot() {
      return (
        Array.isArray(this.metadata?.managerlist)
        && this.metadata.managerlist.includes(this.userid)
        && !!this.task?.botid
      );
    },
    hasUnreadComments() {
      return !this.task?.conversation_read;
    },
  },
  methods: {
    closeMenu() {
      this.$emit('toggle', false);
    },
    onEditTask() {
      if (this.isEditLocked) return;
      this.$emit('edit-task', this.task);
      this.closeMenu();
    },
    onLinkNoa() {
      this.$emit('open-link-bot', this.task);
      this.closeMenu();
    },
    onDelete() {
      this.$emit('delete-checklist-item', this.task);
      this.closeMenu();
    },
    onActivityLog() {
      this.$emit('open-activity-log', this.task);
      this.closeMenu();
    },
    onComments() {
      this.$emit('open-comments', this.task);
      this.closeMenu();
    },
    onWorkpaperTemplate() {
      this.$emit('workpaper-template');
      this.closeMenu();
    },
    onHelpdesk() {
      this.$emit('open-helpdesk', this.task);
      this.closeMenu();
    },
    onUnlinkBot() {
      this.$emit('unlink-bot', this.task);
      this.closeMenu();
    },
    onViewDetails() {
      this.$emit('view-task-details', this.task);
      this.closeMenu();
    },
  },
};
</script>
